import { EntiteSARPModel } from './entite-sarp.model';
import { AgenceModel } from './agence.model';

export class RegionModel extends EntiteSARPModel {
    public agences?: AgenceModel[];
}
